import ecgViewerComponent from './ecgViewer.component';

const ecgViewerModule = angular.module('app.components.clinicalData.ecgViewer', [])
	.component('clinicalDataEcgViewer', ecgViewerComponent)
	.name;

export default ecgViewerModule;
